import {useLogger} from '#imports';
import {Configuration, PublicSkillSuggestionApi} from '@api';
import type {Skill} from '../types/Skill';

export function useSkillSearch() {
    const _api = new PublicSkillSuggestionApi(new Configuration({basePath: ''}));
    const logger = useLogger();

    async function autocomplete(query: string, selectedLabels: string[] = []): Promise<Skill[]> {
        try {
            const existingSkillsMatchingQuery = await _api.autocomplete({query});
            const selectedLabelsSet = new Set(selectedLabels.map((label) => label.toLowerCase()));
            const suggestions = existingSkillsMatchingQuery.map((skill) => ({
                label: skill.label,
                occurrences: skill.occurrences,
                selected: selectedLabelsSet.has(skill.label.toLowerCase()),
            }));

            const skillFromQuery: Skill = {
                label: query,
                occurrences: 0,
                selected: selectedLabelsSet.has(query.toLowerCase()),
            };
            if (_skillsDontContainQuery(suggestions, query)) {
                return [skillFromQuery, ...suggestions];
            }

            return suggestions;
        } catch (error: any) {
            logger.error('useSkillSearch - autocomplete failed with error: ', error);
        }

        return Promise.resolve([]);
    }

    async function suggest(category: string): Promise<Skill[]> {
        try {
            const suggestionMatchingQuery = await _api.findSuggestions({category});
            return suggestionMatchingQuery.map((skill): Skill => ({label: skill.tag}));
        } catch (error: any) {
            logger.error('useSkillSearch - suggest failed with error: ', error);
        }

        return Promise.resolve([]);
    }

    // Private functions
    function _skillsDontContainQuery(suggestions: Skill[], query: string) {
        return !suggestions.some((skill) => skill.label.toLowerCase() === query.toLowerCase());
    }

    return {
        autocomplete,
        suggest,
    };
}
